import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { g as getLocale } from './utils2.js';
import { D as DEFAULT_LANG } from './const.js';

const mapyReviewBadgeNewCss = ":host{display:inline-flex;justify-content:center;align-items:center;font-family:Arial, Helvetica, sans-serif;font-weight:700;letter-spacing:0px;--gray-color:#6D6D6D;--green-color:#1eae00;color:var(--gray-color);border:1px solid var(--gray-color);background:#fff;width:28px;height:28px;border-radius:6px;font-size:16px;line-height:24px;box-sizing:border-box}:host([top]){background:var(--green-color);border-color:var(--green-color);color:#fff}:host([size=small]){width:20px;height:20px;border-radius:4px;font-size:12px;line-height:16px}:host([size=medium]){width:28px;height:28px;border-radius:6px;font-size:16px;line-height:24px}:host([size=big]){width:36px;height:36px;border-radius:8px;font-size:20px;line-height:24px}";
const MapyReviewBadgeNewStyle0 = mapyReviewBadgeNewCss;

const MapyReviewBadgeNew = /*@__PURE__*/ proxyCustomElement(class MapyReviewBadgeNew extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.top = false;
        this.size = "medium";
        this.rating = 0;
    }
    render() {
        let value = this.rating.toLocaleString(DEFAULT_LANG, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
        try {
            value = this.rating.toLocaleString(getLocale(this.hostElement), { minimumFractionDigits: 1, maximumFractionDigits: 1 });
        }
        catch (ex) {
            //
        }
        return h(Host, { key: '8662c4789bd1b5fd06d49516b28a3b203b725b4f' }, value);
    }
    get hostElement() { return this; }
    static get style() { return MapyReviewBadgeNewStyle0; }
}, [1, "mapy-review-badge-new", {
        "top": [516],
        "size": [513],
        "rating": [514]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["mapy-review-badge-new"];
    components.forEach(tagName => { switch (tagName) {
        case "mapy-review-badge-new":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, MapyReviewBadgeNew);
            }
            break;
    } });
}
defineCustomElement();

export { MapyReviewBadgeNew as M, defineCustomElement as d };

//# sourceMappingURL=mapy-review-badge-new2.js.map